<ng-container>
	<div class="error-page">
		<div>
			<h1 data-h1="404">404</h1>
			<p>Page Not Found...</p>
		</div>
	</div>
</ng-container>
